module.exports = "/_next/static/images/BadgeMidMarket@2x-60e434bb31be19cae28b5c814affa774.png";